
































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Table from '@/components/tables/Table.vue'
import TableSubRow from '@/components/tables/TableSubRow.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import { formatTransactionEffectiveDate, getPaidByForDescription } from '@/utils/helpers'
import { EPaymentStatus } from '@zunta/configurations'
import { ITableConfig } from '@/interfaces'

@Component({
  props: {
    paymentStatus: {
      type: Object,
      required: true
    }
  },
  components: { TableSubRow, Table }
})
export default class PaymentProcessedSubrow extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EPaymentStatus: any = EPaymentStatus
  formatTransactionEffectiveDate: Function = formatTransactionEffectiveDate
  getPaidByForDescription: Function = getPaidByForDescription

  config: ITableConfig = {
    columns: [
      {
        minWidth: '200px',
        width: 33,
        key: 'effectiveDate',
        label: 'Effective Date'
      },
      {
        minWidth: '200px',
        width: 33,
        key: 'payerType',
        label: 'Payer Type'
      },
      {
        minWidth: '200px',
        width: 33,
        key: 'amountPaid',
        label: 'Amount Paid'
      }
    ]
  }

  configReject: any = {
    fetchFunction: this.fetchPaymentTransactions,
    columns: [
      {
        width: 33,
        key: 'effectiveDate',
        label: 'Effective Date'
      },
      {
        width: 33,
        key: 'payerType',
        label: 'Payer Type'
      },
      {
        width: 33,
        key: 'amountPaid',
        label: 'Amount Paid'
      }
    ]
  }

  get payment () {
    return this.$props.paymentStatus.payment
  }
  get rejectTransactions () {
    if (this.payment && this.payment.rejectPayment) {
      return this.payment.rejectPayment.appliedTo
    }
    return []
  }
  get originalPaymentHasSurcharge () {
    return this.payment &&
    this.payment.originalPayment &&
    this.payment.originalPayment.surcharge &&
    this.payment.originalPayment.surcharge > 0
  }

  get hasSurcharge () {
    return this.payment && this.payment.surcharge && this.payment.surcharge > 0
  }

  getLocaleDate (date: any) {
    // @ts-ignore
    return new Date(date).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' })
  }

  async fetchPaymentTransactions () {
    await this.paymentsModuleInstance.getRejectTransactions(this.payment.id)
  }

  showPaymentDeclinedReason () {
    if (
      this.payment.resident &&
      this.payment.resident.id &&
      this.payment.declinedReason &&
      this.payment.declinedReason.includes(
        'accountId should not be empty","accountId must be a number conforming to the specified constraints'
      )
    ) {
      return `Payment account for ${this.payment.residentPaymentMethod.type === 'CREDIT_CARD' ? 'Credit Card' : 'eCheck'} has not been set up yet`
    } else if (this.payment.declinedReason) {
      return this.payment.declinedReason
    } else {
      return 'Declined reason unavailable'
    }
  }
}
